<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.incident_form @click="edit = false" variant="primary" size="sm" class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <div class="d-flex flex-row">
            <span class="iconsminds-plaster mr-3 menu-icon-style" style="font-size: 23px;"/>

            <piaf-breadcrumb heading="Incidents"/>

<!--            <p class="my-auto">-->
<!--                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                officiis quia quos rem totam vitae.-->
<!--            </p>-->
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchIncident" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{ meta.from }}-{{ meta.to }} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">
                        {{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"/>

        <b-card class="mb-4" title="List of Incidents">
            <b-refresh-button class="text-data-link" @click="refreshData"/>

            <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                     :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                     :current-page="meta.current_page" :fields="table_fields" :items="fetchIncidents">
<!--                <template v-slot:cell(id)="data">-->
<!--                    <router-link class="text-data-link" :to="data.item.links.self"-->
<!--                                 v-text="data.item.data.attributes.code"/>-->
<!--                </template>-->

                <template v-slot:cell(id)="data">
                    <span v-text="data.item.data.attributes.code"/>
                </template>

                <template v-slot:cell(date)="data">
                    <span v-text="data.item.data.attributes.date"/>
                </template>

                <template v-slot:cell(time)="data">
                    <span v-text="data.item.data.attributes.time"/>
                </template>

                <template v-slot:cell(priority)="data">
                    <span v-text="data.item.data.attributes.priority"/>
                </template>

                <template v-slot:cell(facility)="data">
                    <span v-text="data.item.data.attributes.facility"/>
                </template>

                <template v-slot:cell(incident_type)="data">
                    <span v-text="data.item.data.attributes.incident_type"/>
                </template>

                <template v-slot:cell(reviewed_by)="data">
                    <span v-text="data.item.data.attributes.reviewed_by"/>
                </template>

                <template v-slot:cell(status)="data">
                    <b-badge pill style="width: 85px;"
                             :variant="data.item.data.attributes.status === 'Reviewed' ? 'success' : 'warning'">
                        {{ data.item.data.attributes.status }}
                    </b-badge>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                menu-class="mt-2" style="width: 75px;" right no-caret>
                        <template slot="button-content">
                            <i class="btn-circle simple-icon-options-vertical"/>
                        </template>

                        <b-dropdown-item :to="data.item.links.self">
                            Summary
                        </b-dropdown-item>

                        <b-dropdown-item @click="editIncident(data.item.incident_id)">
                            Edit
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteIncident(data.item)">
                            Delete
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>

            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>

        <IncidentFormModal :edit="edit" @updated="tableKey++"/>
    </div>
</template>

<script>
import _ from "lodash";
import {mapGetters} from "vuex";
import IncidentFormModal from "./modals/IncidentFormModal";

export default {
    name: "IncidentsList",

    components: {
        IncidentFormModal
    },

    data() {
        return {
            loading: true,
            tableKey: 0,
            edit: false,
        }
    },

    computed: {
        ...mapGetters({
            table_fields: 'getIncidentTableFields',
            meta: 'getIncidentsMeta',
        }),
    },

    methods: {
        fetchIncidents() {
            return this.$store.dispatch('fetchIncidents')
                .then(vendors => {
                    return vendors.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        editIncident(incident_id) {
            this.edit = true;

            this.$store.dispatch('fetchEditIncident', incident_id)
                .finally(response => {
                    this.$bvModal.show('incident_form');
                });
        },

        refreshData() {
            this.$store.commit('resetIncidentsMeta');
            this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
        },

        changeSorting(event) {
            (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
        },

        changeOrderBy(key, label) {
            this.meta.order_by = label;
            this.meta.sort_by = key;
        },

        searchIncident: _.debounce(function (event) {
            if (this.meta.search && this.meta.search.length >= 3) {
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            }
        }, 300),

        changePageSize(per_page) {
            this.meta.per_page = per_page;
        },
    }
}
</script>

<style scoped>

</style>
